import { useKGetList } from './../../../services/hooks/useKGetList'
import { Customer } from 'services/api/entities/crm/pmi'
import { Supplier } from 'services/api/entities/crm/suppliers'

export const getEmailName = (customer: Customer) =>
  `${customer.email} - ${customer.name}`

export const useCustomersOptionList = () =>
  [useKGetList<Customer>('pmi'), useKGetList<Supplier>('suppliers')]
    .flat()
    .map((customer) => ({
      id: customer.id,
      name: getEmailName(customer),
    }))
